import React, { useEffect, useState } from "react";
import { withApollo } from "react-apollo";
import { Card, Select, message, Col } from "antd";
import { FundProjectionScreenOutlined } from "@ant-design/icons";

// COMPONENTS
import LaunchCampaignLiquidMConfig from "./LaunchCampaignLiquidMConfig";
import { LaunchCampaignJamLoopConfig } from "./LaunchCampaignJamLoopConfig";

const LaunchCampaignConfig = ({
  client,
  publishers,
  selectedCampaignOrder,
  handleSubmitCampaignOrder,
}) => {
  const [isLaunchCampaignDisabled, setIsLaunchCampaignDisabled] = useState(
    false
  );
  const [dspType, setDspType] = useState("LIQUIDM");
  useEffect(() => {
    if (selectedCampaignOrder && selectedCampaignOrder.dspConfig) {
      setDspType(selectedCampaignOrder.dspConfig.name);
    }
  }, [selectedCampaignOrder]);

  const handleSubmitCampaign = async ({ dspConfig }) => {
    try {
      message.loading(
        `${
          selectedCampaignOrder.status === "APPROVED" ? "Launching" : "Updating"
        } campaign order...`,
        0
      );

      const result = await handleSubmitCampaignOrder({
        dspType,
        dspConfig,
      });

      if (result && result.graphQLErrors && result.graphQLErrors.length) {
        throw new Error(
          result.graphQLErrors.map(({ message }) => message).join(", ")
        );
      }
      message.destroy();
      message.success(
        `Campaign ${
          selectedCampaignOrder.status === "APPROVED" ? "launch" : "update"
        } successfully`
      );
    } catch (error) {
      message.destroy();
      message.error(error.message, 5);
    }
  };

  return (
    <Card
      style={{}}
      title={
        <div style={{ position: "relative" }}>
          <Col>
            <span>
              <FundProjectionScreenOutlined /> Launch Settings
            </span>
          </Col>
        </div>
      }
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 8,
          gap: 8,
        }}
      >
        <Select
          value={dspType}
          style={{
            width: 120,
          }}
          onChange={value => setDspType(value)}
          disabled={
            selectedCampaignOrder && selectedCampaignOrder.status === "LIVE"
          }
          options={[
            {
              value: "LIQUIDM",
              label: "LIQUIDM",
            },
            {
              value: "JAMLOOP",
              label: "JAMLOOP",
            },
          ]}
        />
      </div>
      <div>
        {dspType === "LIQUIDM" && (
          <LaunchCampaignLiquidMConfig
            client={client}
            publishers={publishers}
            selectedCampaignOrder={selectedCampaignOrder}
            handleSubmitCampaignOrder={handleSubmitCampaignOrder}
            isLaunchCampaignDisabled={isLaunchCampaignDisabled}
            setIsLaunchCampaignDisabled={setIsLaunchCampaignDisabled}
            handleSubmitCampaign={handleSubmitCampaign}
          />
        )}

        {dspType === "JAMLOOP" && (
          <LaunchCampaignJamLoopConfig
            selectedCampaignOrder={selectedCampaignOrder}
            isLaunchCampaignDisabled={isLaunchCampaignDisabled}
            handleSubmitCampaign={handleSubmitCampaign}
          />
        )}
      </div>
    </Card>
  );
};

export default withApollo(LaunchCampaignConfig);
